// Sentry initialization should be imported first!
import "./instrument.js";
import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  TimeScale,
  Title,
  Tooltip,
} from "chart.js";
import "chartjs-adapter-moment";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "../src/app/App";
import "./index.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
);

const root = createRoot(document.getElementById("root"));
root.render(<App />);
